<template>
  <div
    id="rating-modal-add"
    class="rating-modal vp-width-416"
    :class="{ 'add-margin-top-bottom': !addSeperator }"
  >
    <p class="rating-modal-title">{{ $t('signInOut.pleaseFillTheFollowingFields')}}</p>
    <template v-if="!isSignInMassAction">
      <template v-if="isDailyLogScanTable">
        <div class="section-title-container">
          <h4 class="scan-section-title">{{ section && section.name }}</h4>
        </div>
      </template>

      <template v-else-if="preReg">
        <h4 class="section-title">{{ section && section.name }}</h4>
      </template>

      <template v-else>
        <h4 class="section-default-title">{{ section && section.name }}</h4>
      </template>
    </template>

    <template
      v-if="section && section.custom_fields && section.custom_fields.length"
    >
      <div
        v-for="(field, index) of section.custom_fields"
        :key="index"
        :class="{ 'add-margin-top-bottom': !addSeperator }"
      >
        <template v-if="field.type == 'checkboxes'">
          <CheckboxField :field="field" @updateField="updateField"
        /></template>
        <template v-else-if="field.type == 'radioButtons'"
          ><RadioButtonField :field="field" @updateField="updateField"
        /></template>
        <div
          v-else-if="field.type == 'text'"
          :class="{ 'vp-mb-16': hasBottomMargin(index) }"
        >
          <TextField
            :field="field"
            @updateTextEmit="updateField"
            :hasBottomMargin="hasBottomMargin(index)"
            :lastFieldInSection="index == section.custom_fields.length - 1"
          />
        </div>
        <div
          v-else-if="field.type == 'number'"
          :class="{ 'vp-mb-16': hasBottomMargin(index) }"
        >
          <NumberField :field="field" @updateNum="updateField" />
        </div>
        <div
          v-else-if="field.type == 'date'"
          :class="{ 'vp-mb-16': hasBottomMargin(index) }"
        >
          <DateField :field="field" @updateDatePicker="updateField" />
        </div>
        <div
          v-else-if="field.type == 'longText'"
          :class="{ 'vp-mb-16': hasBottomMargin(index) }"
        >
          <LongTextField :field="field" @updateLongText="updateField" />
        </div>
        <template v-else-if="field.type == 'ratingScale'"
          ><RatingScaleField
            :field="field"
            :isAddVisit="isAddVisit"
            :preReg="preReg"
            :isEdit="isEdit"
            :isSignInMassAction="isSignInMassAction"
            :signin="signin"
            @updateRating="updateField"
        /></template>
        <div
          v-else-if="field.type == 'toggleButton'"
          :class="{ 'vp-mb-16': hasBottomMargin(index) }"
        >
          <ToggleButtonField :field="field" @updateToggle="updateField" />
        </div>

        <template
          v-if="
            // “Checkboxes”, “Radio buttons” or “Rating scale” field should be followed by a separator.
            index + 1 < section.custom_fields.length &&
            (field.type == 'checkboxes' ||
              field.type == 'radioButtons' ||
              field.type == 'ratingScale' ||
              // OR > separator should be displayed below the “Text”, “Long text”, “Number”, “Date” or
              // “Toggle button” field, only if it is followed by a “Checkboxes”, “Radio buttons” or “Rating scale”
              ((field.type == 'text' ||
                field.type == 'longText' ||
                field.type == 'number' ||
                field.type == 'date' ||
                field.type == 'toggleButton') &&
                (section.custom_fields[index + 1].type == 'checkboxes' ||
                  section.custom_fields[index + 1].type == 'radioButtons' ||
                  section.custom_fields[index + 1].type == 'ratingScale')))
          "
        >
          <div v-if="addSeperator" class="all-fields-sep"></div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
import CheckboxField from "@/components/users/section/Checkbox";
import RadioButtonField from "@/components/users/section/Radio";
import TextField from "@/components/users/section/Text";
import NumberField from "@/components/users/section/Number";
import DateField from "@/components/users/section/Date";
import LongTextField from "@/components/users/section/LongText";
import RatingScaleField from "@/components/users/section/RatingScale";
import ToggleButtonField from "@/components/users/section/ToggleButton";

export default {
  components: {
    CheckboxField,
    RadioButtonField,
    TextField,
    NumberField,
    DateField,
    LongTextField,
    RatingScaleField,
    ToggleButtonField,
  },
  props: {
    section: Object,
    addSeperator: Boolean,
    preReg: Boolean,
    isEdit: Boolean,
    signin: Boolean,
    isSignInMassAction: {
      default: false,
      type: Boolean,
    },
    isDailyLogScanTable: {
      default: false,
      type: Boolean,
    },
    isAddVisit: {
      type: Boolean,
      default: false,
    },
    // validation: Object,
  },
  methods: {
    updateField(field) {
      if (this.isSignInMassAction)
        this.$emit("updateCustomField", {
          ...field,
          userId: this.section.userId,
        });
      else this.$emit("updateCustomField", field);
    },
    hasBottomMargin(currentFieldIndex) {
      return (
        currentFieldIndex + 1 < this.section.custom_fields.length &&
        (this.section.custom_fields[currentFieldIndex + 1].type == "text" ||
          this.section.custom_fields[currentFieldIndex + 1].type ==
            "longText" ||
          this.section.custom_fields[currentFieldIndex + 1].type == "number" ||
          this.section.custom_fields[currentFieldIndex + 1].type == "date" ||
          this.section.custom_fields[currentFieldIndex + 1].type ==
            "toggleButton")
      );
    },
  },
};
</script>
<style lang="scss">
.all-fields-sep {
  background: #ebebeb;
  height: 1px;
  //opacity: 0.08;
  margin-top: 24px;
  margin-bottom: 24px;
}
.section-title-container {
  background-color: #f2f2f2;
  margin-bottom: 32px;
  height: 28px;
  width: 416px;
}
.scan-section-title {
  font-weight: 700;
  font-size: 16px;
  line-height: 19.2px;
  color: #4A4A4A;
  margin-inline-start: 16px;
  padding-top: 4px;
}
.section-default-title {
  font-size: 16px;
  font-weight: 700;
  line-height: 17px;
  letter-spacing: 0.25px;
  text-align: start;
  color: #4A4A4A;
  margin-bottom: 32px;
}

.rating-modal-title{
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0%;
  vertical-align: middle;
  color: #4A4A4A;
  margin-top: 16px;
  margin-bottom: 32px;

}
</style>
